import { MenuService } from './../../services/menu.service';
import { Router } from '@angular/router';
import { LocalStorageService } from './../../services/loca-storage.service';
import { Component, OnInit } from '@angular/core';
import { AlertService } from '../../services/alert.service';

@Component({
  selector: 'app-menu-breadcrumbs',
  templateUrl: './menu-breadcrumbs.component.html',
  styleUrls: ['./menu-breadcrumbs.component.scss']
})
export class MenuBreadcrumbsComponent implements OnInit {

  private user: any;
  public userMenu: any[];
  private collapse : boolean = true

  constructor(
    private menuItems: MenuService,
    private storageService: LocalStorageService,
    private router: Router, 
    private alertService : AlertService
  ) { 
    router.events.subscribe((val) => {
      this.collapse = true;
      console.log(this.collapse);
  });
  }

  ngOnInit() { }

  ngAfterViewInit(): void {
    this.storageService.get('auth_user').then((res: any) => {
      this.user = res;
      const urls = this.router.routerState.snapshot.url.split('/');
      console.log('this.menuItems.getNavMenu(urls[1]) :>> ', this.menuItems.getNavMenu(urls[1]));
      this.userMenu = this.menuItems.getNavMenu(urls[1])[0].main[0].children;

      console.log('this.userMenu :>> ', this.userMenu);
    }).catch((e) => {
      console.log('ContentLayoutComponent->ngAfterViewInit', e);
    });
  }

  action(item: any) {

    if(item.ind_permission != undefined && !item.ind_permission ){ 
      this.alertService.openSwal(
        {
          text : 'Lo sentimos su contrato no posee permisos para esta acción.',
          type : 'warning'
        }
      );
      return;
    }

    let makeRoute = `/${item.state}`;

    switch (item.type) {

      case 'link':
        if (item.main_state)
          makeRoute = `/${item.main_state}${makeRoute}`

        this.router.navigate([makeRoute]);
        break;

      case 'sub':
        if (item.children && item.children.length > 0){
          /* Se permite la navegacacion del primer item con permiso */
          let child_permissions = item.children.filter( child => { return child.ind_permission })

          makeRoute = `${makeRoute}/${child_permissions[0].state}`
        }

        if (item.main_state)
          makeRoute = `/${item.main_state}${makeRoute}`

        this.router.navigate([makeRoute]);
        break;

      default:
        break;
    }
  }

  collapse_menu(){

    this.collapse = !this.collapse;

  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/menu-breadcrumbs/menu-breadcrumbs.component.ts